import { theme } from 'components';
import React from 'react';
import styled from 'styled-components';
import { AuthContext } from 'contexts';
import { getDisplayedPreLaunchBanner } from '../../onboarding/util';
import BannerAlert from './BannerAlert';
import {
  PreLaunchLimitedAccess,
  PreLaunchShowingInstructions,
} from './BannerContent';

const PreLaunchBanner = () => {
  const { auth, orgStatus } = React.useContext(AuthContext);

  const displayedType = getDisplayedPreLaunchBanner(auth, orgStatus);
  let bannerContent = null;
  let bannerBgColor = theme.blue1;
  switch (displayedType) {
    case 'showingInstructions': {
      bannerContent = <PreLaunchShowingInstructions />;
      break;
    }
    case 'noAccess': {
      bannerContent = <PreLaunchLimitedAccess />;
      bannerBgColor = theme.alertWarningBgColor;
      break;
    }
    default:
      break;
  }

  return (
    <BannerAlert
      message={<BannerContainer>{bannerContent}</BannerContainer>}
      backgroundColor={bannerBgColor}
      data-cy="onboarding-prelaunch-banner"
    />
  );
};

export default PreLaunchBanner;

const BannerContainer = styled.div`
  flex-flow: row nowrap;
  align-items: center;
`;
